/* AVKAR storefront — cart drawer, predictive search, sticky header, quick-add, lightbox, reveal, wishlist */
(function(){
  var docEl = document.documentElement;
  docEl.classList.add('has-js');

  function money(cents){ return '\u20B9' + Math.round(cents/100).toLocaleString('en-IN'); }
  var $ = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  function toast(msg){
    var t=$('#avkar-toast');
    if(!t){t=document.createElement('div');t.id='avkar-toast';document.body.appendChild(t);}
    t.textContent=msg;t.classList.add('show');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('show');},1800);
  }

  /* ---------- wishlist (localStorage) ---------- */
  var Wish={
    get:function(){try{return JSON.parse(localStorage.getItem('avkar_wish')||'[]')}catch(e){return[]}},
    set:function(w){localStorage.setItem('avkar_wish',JSON.stringify(w));this.count();},
    has:function(id){return this.get().some(function(x){return String(x.id)===String(id);});},
    toggle:function(o){var w=this.get();var i=-1;for(var k=0;k<w.length;k++){if(String(w[k].id)===String(o.id)){i=k;break;}}if(i>-1){w.splice(i,1);toast('Removed from wishlist');}else{w.push(o);toast('Saved to wishlist');}this.set(w);return this.has(o.id);},
    remove:function(id){var w=this.get().filter(function(x){return String(x.id)!==String(id);});this.set(w);},
    count:function(){var n=this.get().length;$$('[data-wish-count]').forEach(function(el){el.textContent=n;el.style.display=n?'inline-flex':'none';});}
  };

  function renderWish(){
    var grid=document.getElementById('wishGrid');if(!grid)return;
    var items=Wish.get();
    if(!items.length){grid.innerHTML='<div class="wish-empty"><p>Your wishlist is empty.</p><a href="/collections/all" class="btn-maroon">Browse Vankis</a></div>';return;}
    grid.innerHTML=items.map(function(p){
      var actions = p.v ? '<div class="wish-actions"><button class="btn-maroon wish-add" data-add-id="'+p.v+'">Add to Cart</button><a class="btn-outline-ink wish-buy" href="/cart/add?id='+p.v+'&quantity=1&return_to=/checkout">Buy Now</a></div>' : '<div class="wish-actions"><a class="btn-maroon" href="'+p.url+'">View Product</a></div>';
      return '<div class="product-card" style="position:relative">'
        +'<button class="wish-x" data-wish-remove="'+p.id+'" aria-label="Remove">&times;</button>'
        +'<a href="'+p.url+'" class="pc-img" style="display:block">'+(p.img?'<img src="'+p.img+'" alt="'+(p.title||'')+'" loading="lazy">':'<div class="pc-ph"></div>')+'</a>'
        +'<div class="pc-body"><a href="'+p.url+'" style="text-decoration:none;color:inherit"><h3 class="pc-name">'+(p.title||'')+'</h3>'
        +'<div class="pc-rate"><span class="pc-stars">\u2605\u2605\u2605\u2605\u2605</span><span class="pc-rev">4.9</span></div>'
        +'<div class="pc-price">'+(p.price||'')+'</div></a>'+actions+'</div></div>';
    }).join('');
  }

  function initHeroSlider(){
    var hs=document.querySelector('.hero-slider');if(!hs)return;
    var slides=[].slice.call(hs.querySelectorAll('.hs-slide'));if(slides.length<1)return;
    var dotsWrap=hs.querySelector('.hs-dots'),idx=0,timer=null;
    var auto=hs.getAttribute('data-autoplay')!=='false';
    var speed=(parseInt(hs.getAttribute('data-speed'),10)||5)*1000;
    if(slides.length<2){if(dotsWrap)dotsWrap.style.display='none';var pa=hs.querySelector('.hs-prev'),na=hs.querySelector('.hs-next');if(pa)pa.style.display='none';if(na)na.style.display='none';return;}
    slides.forEach(function(s,i){var d=document.createElement('button');d.className='hs-dot'+(i===0?' active':'');d.addEventListener('click',function(){go(i);});if(dotsWrap)dotsWrap.appendChild(d);});
    var dots=dotsWrap?[].slice.call(dotsWrap.children):[];
    function go(n){slides[idx].classList.remove('active');if(dots[idx])dots[idx].classList.remove('active');idx=(n+slides.length)%slides.length;slides[idx].classList.add('active');if(dots[idx])dots[idx].classList.add('active');reset();}
    function next(){go(idx+1);}function prev(){go(idx-1);}
    function reset(){if(!auto)return;clearInterval(timer);timer=setInterval(next,speed);}
    var pn=hs.querySelector('.hs-next'),pp=hs.querySelector('.hs-prev');
    if(pn)pn.addEventListener('click',next);if(pp)pp.addEventListener('click',prev);
    reset();
  }

  function initCraft(){
    var stack=document.querySelector('.craft-stack');if(!stack)return;
    var imgs=[].slice.call(stack.querySelectorAll('.craft-img'));if(imgs.length<2)return;
    var i=0;setInterval(function(){imgs[i].classList.remove('active');i=(i+1)%imgs.length;imgs[i].classList.add('active');},4500);
  }

  /* ---------- cart drawer ---------- */
  function setCartCount(n){ $$('[data-cart-count]').forEach(function(el){el.textContent=n;el.style.display=n>0?'inline-flex':'none';}); }
  function openCart(){ document.body.classList.add('drawer-open'); }
  function closeCart(){ document.body.classList.remove('drawer-open'); }

  function renderCart(cart){
    setCartCount(cart.item_count);
    var ship=$('#drawerShip'), body=$('#drawerBody'), foot=$('#drawerFoot');
    if(!body) return;
    var threshold=(window.AVKAR&&window.AVKAR.freeship)||99900, remaining=threshold-cart.total_price, pct=Math.min(100,Math.round(cart.total_price*100/threshold));
    if(ship){ ship.innerHTML = (remaining>0
        ? '<div class="ds-txt">You\'re <b>'+money(remaining)+'</b> away from <b>FREE shipping</b></div>'
        : '<div class="ds-txt" style="color:#1f7a3a"><b>\u2713 Free shipping unlocked!</b></div>')
        + '<div class="ds-track"><div class="ds-fill" style="width:'+pct+'%"></div></div>'
        + (cart.item_count>=3?'<div class="tier-msg win">\u2713 15% OFF unlocked \u2014 auto-applied at checkout</div>':cart.item_count==2?'<div class="tier-msg">10% OFF on now \u00b7 add 1 more for <b>15% OFF</b></div>':cart.item_count==1?'<div class="tier-msg">Add 1 more & unlock <b>10% OFF</b></div>':''); }
    if(cart.item_count===0){
      body.innerHTML='<div class="drawer-empty"><p>Your cart is empty</p><a href="/collections/all" class="btn-maroon">Shop Vankis</a></div>';
      foot.innerHTML=''; return;
    }
    var h='';
    cart.items.forEach(function(it,idx){
      h+='<div class="dline"><a href="'+it.url+'" class="dline-img">'+(it.image?'<img src="'+it.image+'">':'')+'</a>'
       +'<div class="dline-info"><div class="dline-top"><a href="'+it.url+'" class="dline-title">'+it.product_title+'</a>'
       +'<button class="dline-x" data-remove="'+(idx+1)+'" aria-label="Remove">&times;</button></div>'
       +(it.variant_title&&it.variant_title!=='Default Title'?'<div class="dline-var">'+it.variant_title+'</div>':'')
       +'<div class="dline-bot"><div class="dqty"><button data-line="'+(idx+1)+'" data-q="'+(it.quantity-1)+'">\u2212</button><span>'+it.quantity+'</span><button data-line="'+(idx+1)+'" data-q="'+(it.quantity+1)+'">+</button></div>'
       +'<strong>'+money(it.final_line_price)+'</strong></div></div></div>';
    });
    body.innerHTML=h;
    foot.innerHTML='<div class="dcoupon"><input type="text" id="drawerCoupon" placeholder="Discount code" autocomplete="off"><button type="button" data-apply-coupon>Apply</button></div>'
      +'<div class="dfoot-row"><span>Subtotal</span><strong>'+money(cart.total_price)+'</strong></div>'
      +'<div class="dfoot-note">Shipping &amp; taxes calculated at checkout</div>'
      +'<a href="/checkout" class="btn-maroon w-100 dfoot-btn">Checkout Securely</a>'
      +'<a href="/cart" class="dfoot-link">View full cart</a>';
  }

  function fetchCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){renderCart(c);return c;}); }
  function addToCart(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){return r.json();}).then(function(){return fetchCart();}).then(function(c){openCart();return c;})
      .catch(function(){toast('Could not add — try again');});
  }
  function changeLine(line,q){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:q})})
      .then(function(r){return r.json();}).then(function(c){renderCart(c);return c;});
  }

  /* ---------- predictive search ---------- */
  var sTimer;
  function doSearch(q){
    var box=$('#searchResults'); if(!box) return;
    if(!q||q.length<2){box.innerHTML='';return;}
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
      .then(function(r){return r.json();})
      .then(function(d){
        var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        if(!items.length){box.innerHTML='<div class="sr-empty">No matches. Try another search.</div>';return;}
        box.innerHTML=items.map(function(p){
          var img=p.featured_image&&p.featured_image.url?p.featured_image.url:(p.image||'');
          return '<a class="sr-item" href="'+p.url+'">'+(img?'<img src="'+img+'">':'<span class="sr-ph"></span>')+'<span class="sr-meta"><span class="sr-title">'+p.title+'</span><span class="sr-price">'+(p.price?'\u20B9'+p.price:'')+'</span></span></a>';
        }).join('')+'<a class="sr-all" href="/search?q='+encodeURIComponent(q)+'">View all results &rarr;</a>';
      }).catch(function(){});
  }
  function openSearch(){document.body.classList.add('search-open');var i=$('#searchInput');if(i)setTimeout(function(){i.focus();},50);}
  function closeSearch(){document.body.classList.remove('search-open');}

  /* ---------- lightbox ---------- */
  function openLightbox(src,alt){var lb=$('#lightbox'),im=$('#lightboxImg');if(!lb)return;im.src=src;im.alt=alt||'';lb.classList.add('open');}
  function closeLightbox(){var lb=$('#lightbox');if(lb)lb.classList.remove('open');}

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click',function(e){
    var t=e.target;
    var wish=t.closest('[data-wish-id]');
    if(wish){e.preventDefault();var on=Wish.toggle({id:wish.getAttribute('data-wish-id'),v:wish.getAttribute('data-wish-variant')||'',title:wish.getAttribute('data-wish-title')||'',url:wish.getAttribute('data-wish-url')||'#',img:wish.getAttribute('data-wish-img')||'',price:wish.getAttribute('data-wish-price')||''});wish.classList.toggle('active',on);if(document.getElementById('wishGrid'))renderWish();return;}
    var wrm=t.closest('[data-wish-remove]');
    if(wrm){e.preventDefault();Wish.remove(wrm.getAttribute('data-wish-remove'));renderWish();return;}
    var qa=t.closest('[data-add-id]');
    if(qa){e.preventDefault();qa.classList.add('loading');addToCart(qa.getAttribute('data-add-id'),1).then(function(){qa.classList.remove('loading');});return;}
    if(t.closest('[data-open-cart]')){e.preventDefault();openCart();fetchCart();return;}
    if(t.closest('[data-close-cart]')||t.closest('[data-overlay]')){closeCart();return;}
    if(t.closest('[data-apply-coupon]')){var ce=document.getElementById('drawerCoupon');if(ce&&ce.value.trim()){window.location.href='/discount/'+encodeURIComponent(ce.value.trim())+'?redirect=/cart';}return;}
    if(t.closest('[data-open-search]')){e.preventDefault();openSearch();return;}
    if(t.closest('[data-close-search]')){closeSearch();return;}
    if(t.closest('[data-close-lightbox]')){closeLightbox();return;}
    var rm=t.closest('[data-remove]'); if(rm){e.preventDefault();changeLine(parseInt(rm.getAttribute('data-remove')),0);return;}
    var dq=t.closest('.dqty button'); if(dq){e.preventDefault();changeLine(parseInt(dq.getAttribute('data-line')),parseInt(dq.getAttribute('data-q')));return;}
    var zoom=t.closest('[data-zoom]'); if(zoom){var im=zoom.querySelector('img')||zoom;openLightbox(zoom.getAttribute('data-zoom')||im.src,im.alt);return;}
  });

  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();closeSearch();closeLightbox();}});

  /* product form -> ajax add + open drawer */
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(f.id==='pform'){
      e.preventDefault();
      var fd=new FormData(f); var id=fd.get('id'); var qty=parseInt(fd.get('quantity'))||1;
      var btn=f.querySelector('[name=add]'); if(btn)btn.classList.add('loading');
      addToCart(id,qty).then(function(){if(btn)btn.classList.remove('loading');});
    }
  });

  /* search input */
  document.addEventListener('input',function(e){ if(e.target.id==='searchInput'){clearTimeout(sTimer);var q=e.target.value;sTimer=setTimeout(function(){doSearch(q);},220);} });

  /* sticky header */
  var hdr=$('#siteHeader'), last=0;
  window.addEventListener('scroll',function(){var y=window.pageYOffset;if(hdr)hdr.classList.toggle('scrolled',y>60);last=y;},{passive:true});

  /* reveal on scroll + mark wishlist + initial cart count */
  function ready(){
    Wish.count();
    $$('[data-wish-id]').forEach(function(b){if(Wish.has(b.getAttribute('data-wish-id')))b.classList.add('active');});
    if(document.getElementById('wishGrid'))renderWish();
    initHeroSlider();
    initCraft();
    var rev=$$('.section, .video-band'); rev.forEach(function(el){el.classList.add('reveal');});
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.08});
      rev.forEach(function(el){io.observe(el);});
    } else { rev.forEach(function(el){el.classList.add('in');}); }
  }
  if(document.readyState!=='loading')ready();else document.addEventListener('DOMContentLoaded',ready);
})();
